import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap, throwError } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { IRoom } from "./iroom";


@Injectable({ providedIn: 'root' })
export class RoomService {

    private _room: BehaviorSubject<IRoom | null> = new BehaviorSubject<IRoom | null>(null);
    private _rooms: BehaviorSubject<IRoom[]> = new BehaviorSubject<IRoom[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get room$(): Observable<IRoom | null> {
        return this._room.asObservable();
    }

    get rooms$(): Observable<IRoom[]> {
        return this._rooms.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getAllRooms(room: PaginationRequest & { roomTypeId?: number | null }): Observable<BaseRespone<{ pagination: PaginationResult; roomDetails: IRoom[] }>> {
        const requestBody = { ...room };

        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; roomDetails: IRoom[] }>>(`${environment.baseURl}/Room/list`, requestBody).pipe(
            tap(response => {
                this._pagination.next(response.result.pagination);
                this._rooms.next(response.result.roomDetails);
            }),
            catchError(error => {
                console.error('Error fetching data:', error);
                throw error;
            })
        );
    }

    createRoom(roomDetails: IRoom): Observable<BaseRespone<IRoom>> {
        return this._httpClient.post<BaseRespone<IRoom>>(`${environment.baseURl}/Room`, roomDetails)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newtype) => {
                    // Return the new
                    return newtype;
                })
            )
    }

    deleteRoom(id: number): Observable<BaseRespone<boolean>> {
        return this.rooms$.pipe(
            take(1),
            switchMap(rooms =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/Room/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const updated = rooms.filter(item => item.id !== id);
                            this._rooms.next(updated);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    updateRoom(roomDetails: IRoom): Observable<BaseRespone<IRoom>> {
        return this.rooms$.pipe(
            take(1),
            switchMap(rooms => this._httpClient.put<BaseRespone<IRoom>>(`${environment.baseURl}/Room`, roomDetails).pipe(
                map((updated: BaseRespone<IRoom>) => {
                    // Find the index of the updated product
                    const index = rooms.findIndex(item => item.id === roomDetails.id);

                    // Update the product
                    rooms[index] = roomDetails;

                    // Update the products
                    this._rooms.next(rooms);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }
}